﻿import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { INestedElement } from "@models/entity-models";
import { Configurator } from "./configurator";

@Kbo(CToken.NestedElement)
export class NestedElement extends UiObject implements INestedElement {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    private _configurator: Configurator;
    public get configurator(): Configurator {
        return this._configurator;
    }
    public set configurator(val: Configurator) {
        this._configurator = val;
    }
}
